/**
 * Deterministic Guids for InterviewResultParameter
 * (EtlGuid: `InterviewResultParameter:{legacyId}`).
 *
 * Otoriter kaynak: services/Wiser-ATS-BE/Data/Seeding/Sql/system/020_InterviewResultParameter.sql
 * Backend karsiligi: Helper/ParameterGuids/InterviewResultParameterGuids.cs
 * Dogrulama: python scripts/audit_fe_guid_constants.py
 *
 * DIKKAT: legacy id'ler sirali degil — 1,2,3,4,5 sonra 12,13,14 (6-11 yok).
 * Yeni deger eklerken seed SQL'i ADIYLA okuyun, sirayi varsaymayin.
 */
export const InterviewResultParameterGuids = {
  olumlu: "1b328d3e-8428-548e-89a9-0e46422f52d8", // 1 OLUMLU
  olumsuz: "616313fb-11f6-5c0e-9dfd-8d0ce18e6080", // 2 OLUMSUZ
  gorusme2: "c0b03921-9fbc-5613-a0fb-95f8a544343d", // 3 2. GÖRÜŞME
  gorusme3: "d5fca1e1-733a-500b-bcff-52242f2379b0", // 4 3. GÖRÜŞME
  iptal: "12205dbc-ee81-5932-b3af-27820d71bd57", // 5 İPTAL
  gorusmeBekliyor: "5b4c52d2-e4b1-59d9-b5b2-11cde9b8b449", // 12 GÖRÜŞME BEKLİYOR
  musteriDegerlendirmesiBekleniyor: "571122f4-746e-5a24-8dbf-c84bfc46f6a6", // 13 MÜŞTERİ DEĞERLENDİRMESİ BEKLENİYOR
  beklemede: "f0563814-3614-5bb1-8296-47bcb1b6b813", // 14 BEKLEMEDE
} as const;

/**
 * "Olumsuz" mulakat sonucu mu?
 *
 * Upstream'de bu kontrol `interviewResultId === 2` idi; bizde id'ler Guid oldugu
 * icin o karsilastirma hicbir zaman tutmazdi. Guid karsilastirmasi asil yol;
 * etiket kontrolu upstream'den gelen yedek (parametre tablosuna yeni bir
 * "olumsuz" satiri eklenirse yine yakalar).
 */
export const isNegativeInterviewResult = (
  interviewResultId: string | null | undefined,
  interviewResultLabel?: string | null,
): boolean => {
  if (interviewResultId === InterviewResultParameterGuids.olumsuz) return true;
  return interviewResultLabel?.toLocaleLowerCase("tr-TR") === "olumsuz";
};
